import React from 'react';
import { LiveStreamProps } from './LiveStream';
import { lazy, Suspense } from 'react';
import { ErrorBoundary } from '@SharedScripts/ErrorBoundary';

const LiveStream = lazy(() => import('./LiveStream'));

const LazyLiveStream = (props: LiveStreamProps) => {
  return <ErrorBoundary fallback={<div>Der skete en fejl i indlæsningen af live video</div>}>
    <Suspense fallback={<div>Indlæser live video</div>}>
      <LiveStream {...props} />
    </Suspense>;
  </ErrorBoundary>;
};

export default LazyLiveStream;